export const methods = {
  async reload() {
    this.loading = true

    this.workOrderRequestID = this.$route.params.id || 0

    this.loading = false
  },

  returnToParent() {
    this.$router.push({
      name: 'workOrderRequests',
      params: {
        loadrequests: true
      }
    })
  }
}
